import { DispatchType } from '../../../@types/redux-types'
import {
  getInsertionManualGeoCodingCompletionSuccess,
  gisServiceRequest,
  gisServiceRequestCompleted,
  gisServiceSuccess,
  invalidateGeoCoordinates,
} from '../../reducers/address/addressFeature'
import { getGeoCode } from '../../../api/geographicInformationSystem/geographicInformationSystemApi'
import { InitState } from '../../reducers/root/initialState'
import { showMessage } from '../../reducers/message/messageFeature'
import { GeocodeObject } from '../../../@types/geographicInformationSystem-types'

export const initialManualGeoCodingLoading = () => async (dispatch: DispatchType, getState: () => InitState) => {
  try {
    const insertionData = getState().insertionFeature.insertionData
    let geocodes: GeocodeObject | null | undefined

    dispatch(gisServiceRequest())
    try {
      geocodes = await getGeoCode(insertionData)
      if (geocodes.geocodingResults.length > 0) {
        dispatch(gisServiceSuccess({ coordinates: geocodes }))
      }
      if (geocodes?.geocodingResults.length == 0) {
        dispatch(getInsertionManualGeoCodingCompletionSuccess())
      }
    } finally {
      dispatch(gisServiceRequestCompleted())
    }
  } catch {
    dispatch(showMessage({ message: 'incorrectReverseGeoCode' }))
    dispatch(invalidateGeoCoordinates())
  }
}
